var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 35,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 36,
    height: 36,
    rx: 4.5,
    fill: "#F4F4F7",
    stroke: "#406BBE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5215 11H9.50001V9.5H14.75L15.5 10.25V15.5H14V12.5C12.6556 13.5087 11.689 14.9398 11.2552 16.5637C10.8215 18.1875 10.9458 19.91 11.6081 21.4547C12.2705 22.9995 13.4325 24.277 14.9078 25.0823C16.3831 25.8875 18.0862 26.1739 19.7437 25.8955C21.4013 25.617 22.9172 24.7899 24.0484 23.5467C25.1796 22.3036 25.8604 20.7165 25.9817 19.0401C26.1029 17.3637 25.6575 15.6952 24.717 14.3022C23.7764 12.9092 22.3952 11.8726 20.795 11.3585L21.248 9.9275C23.1899 10.5502 24.8628 11.8139 25.9926 13.5117C27.1224 15.2095 27.6421 17.2406 27.4665 19.2724C27.291 21.3041 26.4306 23.2161 25.0264 24.6949C23.6222 26.1737 21.7573 27.1318 19.7373 27.4122C17.7174 27.6926 15.6621 27.2787 13.9082 26.2382C12.1542 25.1977 10.8056 23.5924 10.0833 21.6853C9.36106 19.7782 9.30788 17.6823 9.93252 15.741C10.5572 13.7997 11.8226 12.1281 13.5215 11Z",
    fill: "#406BBE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.0f910aba17939a80da0d4ed4d994d009.svg";
export { ForwardRef as ReactComponent };